import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ContactBanner.css';

function ContactBanner() {
  return (
    <div className="contact-banner">
      <p>We are <strong>proud</strong> to present our new products and brands to you.</p>
      <Link to="/contact" className="banner-btn">Contact Us Now</Link>
    </div>
  );
}

export default ContactBanner;